import { render, staticRenderFns } from "./CateringPage.vue?vue&type=template&id=6a3dfe96&scoped=true&"
import script from "./CateringPage.vue?vue&type=script&lang=js&"
export * from "./CateringPage.vue?vue&type=script&lang=js&"
import style0 from "./CateringPage.vue?vue&type=style&index=0&id=6a3dfe96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3dfe96",
  null
  
)

export default component.exports